var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrayCheck({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 5,
    viewBox: "0 0 7 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.46228 0.808529C6.43712 0.74783 6.40024 0.692685 6.35375 0.646249C6.30731 0.599761 6.25217 0.562881 6.19147 0.537719C6.13077 0.512557 6.06571 0.499605 6 0.499605C5.93429 0.499605 5.86923 0.512557 5.80853 0.537719C5.74783 0.562881 5.69269 0.599761 5.64625 0.646249L2.5 3.79312L1.35375 2.64625C1.25993 2.55243 1.13268 2.49972 1 2.49972C0.86732 2.49972 0.740072 2.55243 0.646252 2.64625C0.552432 2.74007 0.499724 2.86732 0.499724 3C0.499724 3.13268 0.552432 3.25993 0.646252 3.35375L2.14625 4.85375C2.19269 4.90024 2.24783 4.93712 2.30853 4.96228C2.36923 4.98744 2.43429 5.00039 2.5 5.00039C2.56571 5.00039 2.63077 4.98744 2.69147 4.96228C2.75217 4.93712 2.80732 4.90024 2.85375 4.85375L6.35375 1.35375C6.40024 1.30731 6.43712 1.25217 6.46228 1.19147C6.48744 1.13077 6.50039 1.06571 6.50039 0.999999C6.50039 0.934291 6.48744 0.869228 6.46228 0.808529Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayCheck);
export default __webpack_public_path__ + "static/media/grayCheck.4fc5de4e421c7eb7b453d13cdf776c5e.svg";
export { ForwardRef as ReactComponent };